import React from 'react';
export function PainPointsSection() {
  const pains = [{
    icon: '🌱',
    text: 'Plantas que no crecen'
  }, {
    icon: '😤',
    text: 'Frustración'
  }, {
    icon: '🚫',
    text: 'Abandono'
  }];
  return <section className="relative bg-white py-8 px-4 sm:px-6 lg:px-8" data-id="element-78">
      <div className="max-w-5xl mx-auto" data-id="element-79">
        <div className="text-center mb-6" data-id="element-80">
          <h2 className="font-serif text-3xl sm:text-4xl font-black text-[#1A1A1A] mb-2" data-id="element-81">
            ⚠️ El problema no es el espacio… ni el tiempo
          </h2>
          <p className="text-base sm:text-lg text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-82">
            Es que nadie te enseñó cómo hacerlo de forma simple.
          </p>
        </div>

        <p className="text-center text-base font-semibold text-gray-700 mb-4" data-id="element-83">
          Intentar sin guía termina en:
        </p>

        <div className="grid grid-cols-3 gap-3 sm:gap-5 mb-6 max-w-2xl mx-auto" data-id="element-84">
          {pains.map((pain, i) => <div key={i} className="bg-neutral-bg rounded-2xl p-4 text-center shadow-md hover:shadow-xl transition-all duration-300 border border-transparent hover:border-earth-light/50 group transform hover:-translate-y-1" data-id="element-85">
              <div className="text-3xl mb-2 transform group-hover:scale-110 transition-transform duration-300" data-id="element-86">
                {pain.icon}
              </div>
              <p className="text-sm font-bold text-gray-800 leading-snug" data-id="element-87">
                ❌ {pain.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-88">
          <p className="font-serif text-lg sm:text-xl font-black text-garden-dark bg-neutral-bg px-6 py-3 rounded-2xl shadow-md inline-block mx-auto border border-garden-bg relative overflow-hidden" data-id="element-89">
            <span className="absolute top-0 left-0 w-full h-1 bg-gradient-garden" data-id="element-90"></span>
            Y vuelves al mismo punto.
          </p>
        </div>
      </div>
    </section>;
}